export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_USER_STOREROOM = 'SET_USER_STOREROOM'
export const SET_CARD_PREFERENCES = 'SET_CARD_PREFERENCES'
export const SET_CARD_COLLAPSE = 'SET_CARD_COLLAPSE'
export const SET_USER_ROLES = 'SET_USER_ROLES'
export const SET_IS_DC_USER = 'SET_IS_DC_USER'
export const SET_AREA_OR_LOCATION = 'SET_AREA_OR_LOCATION'
